<template>
  <div v-if="showBanner" class="cookie-consent">
    <div v-if="!showPreferences" class="cookie-message">
      <p>{{ $t("cpts.cookies_consent.instructions") }}</p>
      <el-button type="primary" round @click="acceptAllCookies">{{ $t("cpts.cookies_consent.actions.accept") }}</el-button>
      <el-button type="info" round @click="showPreferences = true">{{ $t("cpts.cookies_consent.actions.setting") }}</el-button>
    </div>
    <div v-if="showPreferences" class="cookie-preferences">
      <h2>{{ $t("cpts.cookies_consent.settings.title") }}</h2>
      <div class="flex justify-center items-center my-[20px]">
        <el-checkbox v-model="preferences.analytics" class="text-white">{{ $t("cpts.cookies_consent.settings.options.analytics") }}</el-checkbox>
        <el-checkbox v-model="preferences.marketing" class="text-white">{{ $t("cpts.cookies_consent.settings.options.marketing") }}</el-checkbox>
      </div>
      <el-button  type="primary" round @click="savePreferences">{{ $t("cpts.cookies_consent.settings.save") }}</el-button>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { EventBus } from './event-bus';

export default {
  data() {
    return {
      showBanner: !Cookies.get('cookieConsent'),
      showPreferences: false,
      preferences: {
        analytics: Cookies.get('analytics') === 'true',
        marketing: Cookies.get('marketing') === 'true',
      }
    };
  },
  mounted() {
    EventBus.$on('showCookiePreferences', this.handleEvent);
  },
  methods: {
    acceptAllCookies() {
      this.setCookies({ analytics: true, marketing: true });
    },
    savePreferences() {
      this.setCookies(this.preferences);
    },
    setCookies(preferences) {
      Cookies.set('cookieConsent', true, { expires: 365 });
      Cookies.set('analytics', preferences.analytics, { expires: 365 });
      Cookies.set('marketing', preferences.marketing, { expires: 365 });
      this.showBanner = false;
    },
    handleEvent(message) {
      this.showBanner = true;
      this.showPreferences = true; 
    }
  },
  beforeDestroy() {
    EventBus.$off('showCookiePreferences', this.handleEvent);
  },
};
</script>

<style scoped>
.cookie-consent {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 20px;
  text-align: center;
}

.cookie-message p {
  margin: 0 0 10px;
}

.cookie-preferences {
  margin-top: 20px;
}

.cookie-preferences h2 {
  margin-bottom: 10px;
}

.cookie-preferences label {
  display: block;
  margin-bottom: 10px;
}
</style>
